import { StatusCodes } from 'http-status-codes'

export const successHandler = (response: any) => {
  if (response.data.hasOwnProperty('error')) {
    return Promise.reject(response)
  }
  return response
}

export const failHandler = (error: any) => {
  const { status } = error.response

  if (status !== StatusCodes.UNAUTHORIZED && status !== StatusCodes.INSUFFICIENT_SPACE_ON_RESOURCE) {
    return Promise.reject(error)
  }
  window.location.reload()
}
